import type {RouteParams} from 'types/routes'
import {MYPAGE_PATHS} from 'consts/paths'
import {Index} from 'pages/withAuth/mypage/procedures/childcareLeave/index'

export const ChildcareLeaveRoutes: RouteParams[] = [
  {
    key: '/mypage/childcare_leave',
    path: MYPAGE_PATHS.PROCEDURES.CHILDCARE_LEAVE.INDEX,
    component: Index,
    exact: true,
  },
]
